import React, { useEffect, useState } from 'react';
import { auth } from '../api/fire';

const AuthContext = React.createContext();
AuthContext.displayName = 'AuthContext';

export const AuthProvider = ({ children }) => {
  const [userState, setUserState] = useState(null);
  const [authPending, setAuthPending] = useState(true);

  const signIn = async (username, password) => {
    await auth.signInWithEmailAndPassword(username, password);
  };

  const signUp = (username, password) => {
    auth.createUserWithEmailAndPassword(username, password);
  };

  const signOut = () => auth.signOut();

  useEffect(
    () =>
      auth.onAuthStateChanged((userAuth) => {
        // console.log(userAuth);
        setUserState(userAuth);
        setAuthPending(false);
      }),
    []
  );

  return (
    <AuthContext.Provider
      value={{ authPending, userState, signIn, signUp, signOut }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
